import { Divider, Tooltip } from 'antd';
import React from 'react';
import Icon, { ICON_NAME } from '../../../../components/Icon';
import { datetime } from '../../../../util/library/datetime';
import { InfoMode, SHORT_DATETIME_FORMAT } from '../../../../util/varibles/constants';
import { durationTxt } from '../../../../util/varibles/global';
import { IActivityLog } from '../../../../util/varibles/interface';
import stylesOp from '../Operation/style.module.scss';

interface IProps {
    activity_log: IActivityLog[]
    mode?: InfoMode
}

const OperationTime: React.FC<IProps> = ({ activity_log, mode = InfoMode.PLAN }) => {
    const timeKey = mode === InfoMode.PLAN ? 'est_start_time' : 'real_start_time';
    const startTime = activity_log[0]?.[timeKey];
    const finishTime = activity_log[activity_log.length - 1]?.[timeKey];

    return <div className={stylesOp['info-line']}>
        <span className='flex items-center'>
            <Icon icon={ICON_NAME.CLOCK} bg='colorSub' className='mr-[4px]' />
            <span className='whitespace-nowrap text-comment'>Time, duration:</span>
        </span>
        <span className='flex h-[24px] items-center'>
            {startTime && <Tooltip title="Start time">
                <span className='whitespace-nowrap'>{datetime(startTime).format(SHORT_DATETIME_FORMAT)}</span>
            </Tooltip>}
            {finishTime && <>
                <span className='arrow-right' />
                <Tooltip title="Finish time">
                    <span className='whitespace-nowrap'>{datetime(finishTime).format(SHORT_DATETIME_FORMAT)}</span>
                </Tooltip>
            </>}
            {startTime && finishTime ? <>
                <Divider orientation="vertical" className='h-[20px] mt-1' />
                <Tooltip title="Duration">
                    <span className='whitespace-nowrap'>{durationTxt(finishTime - startTime)}</span>
                </Tooltip>
            </> : '-'}
        </span>
    </div>;
};

export default OperationTime;
